export const link_classes =
  "text-enc-primary-base flex justify-center hover:cursor-pointer hover:no-underline hover:bg-enc-primary-background px-2 py-1 rounded-lg";
